var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "@drklein/client-detection", "hypo_elements/Typescripts/Mustache/Mustache", "hypo_elements/Typescripts/Configuration/Configuration", "jquery"], function (require, exports, client_detection_1, HypoportMustache, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    HypoportMustache = __importStar(HypoportMustache);
    var HEADLINES = {
        BAUFINANZIERUNG: "Gesamtbewertung Berater Baufinanzierung",
        RATENKREDIT: "Gesamtbewertung Berater Ratenkredit",
        VERSICHERUNG: "Gesamtbewertung Berater Versicherung"
    };
    $(function () {
        var kundenbewertungenHeaderSortOptionClass = "kundenbewertungen_headerSortOption";
        var $kundenbewertungsseite = $(".kundenbewertungsseite");
        var $kundenbewertungen = $(".kundenbewertungen");
        var $kundenbewertungenHeader = $(".kundenbewertungenHeader");
        var singleReviewTemplate = $kundenbewertungen.find("#kundenBewertungTemplate");
        var orgTemplate = $kundenbewertungen.find("#kundenBewertungSchemaOrgTemplate");
        var reviewsBody = $kundenbewertungen.find(".kundenbewertungen_body");
        var loadMoreButton = $kundenbewertungen.find(".load_more_reviews");
        var currentQueryData = {
            page: 0,
            size: 10,
            platformProductGroupId: loadMoreButton.data("default-product-group-platform-id"),
            sort: $('#initial-sort-order').data('initial-sort-order')
        };
        /**
         * We need this because otherwise the comma in the sort-parameter gets encoded to createdAt%2Cdesc
         */
        function getEncodedQueryData() {
            return "page=" + currentQueryData.page + "&size=" + currentQueryData.size + "&sort=" + currentQueryData.sort
                + (currentQueryData.platformProductGroupId ? "&platformProductGroupId=" + currentQueryData.platformProductGroupId : "");
        }
        /**
         * load initial reviews
         */
        var reviewPath = loadMoreButton.data("reviews-href");
        $('#review_throbber').show();
        $.get(reviewPath, getEncodedQueryData()).then(function (reviewPage) {
            var $bewertungenTotalCount = $kundenbewertungsseite.find(".kundenbewertungen_headerTotalCount");
            $bewertungenTotalCount.text(reviewPage.page.totalElements.toLocaleString(Configuration_1.configuration.defaultLocale));
            reviewsBody.empty();
            displayReviews(reviewPage);
        });
        /**
         * After a new batch of reviews was loaded (from load-more button, different sorting or product group etc.),
         * add the new reviews to the list
         * @param reviewPage
         */
        function displayReviews(reviewPage) {
            $(".kundenbewertungen_headerSort").show();
            if (HypoportMustache.isTemplateAvailable(singleReviewTemplate) && HypoportMustache.isTemplateAvailable(orgTemplate)) {
                reviewPage._embedded['reviews'] = replaceValues(reviewPage._embedded['reviews'], 'authorPlaceOfResidence', 'Deutschland', '');
                reviewPage._embedded['reviews'].forEach(function (review) {
                    var kundenbewertungSchemaOrgData = { review: review };
                    // OVIT-8714: Remove Schema.org tag Review
                    //reviewsBody.append(HypoportMustache.renderSchemaOrg(orgTemplate, kundenbewertungSchemaOrgData));
                    var createdAt = new Date(review.createdAt);
                    review.createdAt = [createdAt.getUTCDate(), createdAt.getUTCMonth() + 1, createdAt.getFullYear()].join(".");
                    var agent = {};
                    if (review._embedded && review._embedded['agent']) {
                        agent = review._embedded['agent'];
                        // @ts-ignore
                        agent.url = agent.profilePageUrl;
                    }
                    var kundenbewertungData = {
                        review: review,
                        rating: review.rating,
                        formattedRating: review.rating.toString().replace('.', ','),
                        agent: agent
                    };
                    reviewsBody.append(HypoportMustache.render(singleReviewTemplate, kundenbewertungData));
                });
            }
            $('#review_throbber').hide();
            if (reviewPage.page.number < reviewPage.page.totalPages - 1) {
                loadMoreButton.show();
            }
        }
        /**
         * Replaces values in an object
         */
        function replaceValues(obj, field, oldValue, newValue) {
            for (var key in obj) {
                if (obj[key][field] === oldValue) {
                    obj[key][field] = newValue;
                }
            }
            return obj;
        }
        /**
         * Switch product group on tab-click
         */
        $kundenbewertungenHeader.find(".reitermodul_tab").on("click", function () {
            currentQueryData.platformProductGroupId = $($(this).data("tab-for")).data("theme").toUpperCase();
            if (currentQueryData.platformProductGroupId == "DRKLEINDONUT") {
                currentQueryData.platformProductGroupId = '';
            }
            loadMoreButton.hide();
            $('#review_throbber').show();
            reviewsBody.empty();
            $.get(reviewPath, getEncodedQueryData()).then(function (reviewPage) {
                var $bewertungenTotalCount = $kundenbewertungsseite.find(".kundenbewertungen_headerTotalCount");
                $bewertungenTotalCount.text(reviewPage.page.totalElements.toLocaleString(Configuration_1.configuration.defaultLocale));
                displayReviews(reviewPage);
            });
        });
        /**
         * load more reviews when 'load-more'-button is clicked
         */
        loadMoreButton.on("click", function (event) {
            currentQueryData.page++;
            loadMoreButton.hide();
            $('#review_throbber').show();
            $.get(reviewPath, getEncodedQueryData()).then(function (result) { return displayReviews(result); });
            event.preventDefault();
        });
        /**
         * When the sort order changed, reload all reviews in the new order
         */
        $("." + kundenbewertungenHeaderSortOptionClass).on("click", function (event) {
            var $sortButton = $(this);
            var direction = $sortButton.attr("data-direction");
            var newDir = direction === "asc" ? "desc" : "asc";
            currentQueryData.sort = $sortButton.data("orderBy") + "," + newDir;
            $sortButton.attr("data-direction", newDir);
            var sortButtonActiveState = "kundenbewertungen_headerSortOption--is-active";
            $("." + kundenbewertungenHeaderSortOptionClass).removeClass(sortButtonActiveState);
            $sortButton.addClass(sortButtonActiveState);
            reviewsBody.empty();
            currentQueryData.page = 0;
            loadMoreButton.hide();
            $('#review_throbber').show();
            $.get(reviewPath, getEncodedQueryData()).then(function (result) { return displayReviews(result); });
            event.preventDefault();
        });
        /**
         * set the Header-Titles for each tab
         */
        $kundenbewertungenHeader.find(".reitermodul_tab").each(function (index, tab) {
            var productGroupPlatformId = $($(tab).data("tab-for")).data("theme").toUpperCase();
            var headlineElement = $($(tab).data("tab-for")).find(".kundenbewertungenGesamt_headline");
            //show shorter texts on smaller devices
            if (!client_detection_1.MobileDetection.isMobile()) {
                if (HEADLINES[productGroupPlatformId]) {
                    headlineElement.text(HEADLINES[productGroupPlatformId]);
                }
                else {
                    headlineElement.text("Gesamtbewertung alle Berater");
                }
            }
            else {
                headlineElement.text("Gesamtbewertung");
            }
        });
    });
});
